export default {
    namespaced: true,

    state: {
        users: null,
    },

    actions: {
        getUsers({ commit }, emailAddress) {
            return axios.get('/api/admin/users', {
                params: {
                    EmailAddress: emailAddress,
                },
            })
            .then((response) => {
                commit('setUsers', response.data.data);
                return response;
            })
            .catch((error) => {
                commit('setUsers', []);
                return error;
            });
        },
    },

    mutations: {
        setUsers(state, users) {
            state.users = users;
        },
    },
};
